import DatagouvfrAPI from '@/services/api/DatagouvfrAPI'

export default class UserAPI extends DatagouvfrAPI {
  endpoint = 'me'
}
